<template>
  <div class="epcg-tab py-4" :class="{ 'px-8': !breakpointXs, 'px-2': breakpointXs }">
    <div class="epcg-tab__table pt-2">
      <div
        class="epcg-tab__table__header d-sm-flex justify-space-between align-center"
        :class="{ 'text-center': breakpointXs }"
      >
        <v-text-field v-model="search" label="Search" single-line hide-details class="mw-25"></v-text-field>
        <v-btn color="button-primary" class="white--text" :class="{ 'mt-4': breakpointXs }" @click="addNewLicense">
          <span class="font-weight-bold">Add {{ schemeAbbreviation }} </span>
        </v-btn>
      </div>
      <div class="epcg-tab__table__body mt-5">
        <v-data-table :items-per-page="5" :headers="tableHeaders" :items="licenses" :search="search"
          ><template v-slot:item.edit="{ item }">
            <v-btn color="lightPrimary" class="info font-weight-bold" dense @click="updateActionHandler(item)"
              >Edit</v-btn
            >
          </template>
          <template v-slot:item.delete="{ item }">
            <v-btn color="lightPrimary" class=" error font-weight-bold" dense @click="deleteActionHandler(item)"
              >Delete</v-btn
            >
          </template>
        </v-data-table>
      </div>
    </div>
    <v-dialog v-model="dialog" max-width="1000" persistent>
      <v-card :class="{ 'pa-7': !breakpointXs, 'pa-2': breakpointXs }">
        <v-card-title class="justify-space-between">
          <div :class="{ 'fs-25': !breakpointXs, 'fs-20': breakpointXs, 'fw-600': true }">
            Add {{ schemeAbbreviation }}
            <span class="fs-15">(<b>Quantity Unit</b> will be calculated automatically as per registered License)</span>
          </div>
          <v-btn icon @click="dialog = false">
            <v-icon>fas fa-times</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text :class="{ 'pt-5': !breakpointXs, 'pt-0': breakpointXs }">
          <ValidationObserver @keydown.tab="focusNext" v-slot="{ passes }">
            <v-row>
              <v-col cols="12" :xs="12" :sm="6" :md="6" :lg="6">
                <TextField
                  v-model="licenseNo"
                  rules="required|max:25"
                  showIcons
                  required
                  :showOnlyErrorIcons="true"
                  :loading="isTabFormLoading || savingExportJob"
                  label="EDI License No."
                />
              </v-col>
              <v-col cols="12" :xs="12" :sm="6" :md="6" :lg="6">
                <DateField
                  v-model="licenseDate"
                  rules="required"
                  :loading="isTabFormLoading || savingExportJob"
                  :inputLabel="'EDI License Date'"
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" :xs="12" :sm="6" :md="6" :lg="6">
                <TextField
                  v-model="itemsnoPartE"
                  rules="required|max:10"
                  showIcons
                  :showOnlyErrorIcons="true"
                  :loading="isTabFormLoading || savingExportJob"
                  label="Item SNo Part E"
                />
              </v-col>
              <v-col cols="12" :xs="12" :sm="6" :md="6" :lg="6">
                <TextField
                  v-model="itemsnoPartC"
                  showIcons
                  :showOnlyErrorIcons="true"
                  rules="required|max:10"
                  :loading="isTabFormLoading || savingExportJob"
                  label="Item SNo Part C"
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" :xs="12" :sm="6" :md="6" :lg="6">
                <TextField
                  v-model="quantity"
                  type="number"
                  showIcons
                  :showOnlyErrorIcons="true"
                  :loading="isTabFormLoading || savingExportJob"
                  label="Export Quantity"
                />
              </v-col>
              <v-col cols="12" :xs="12" :sm="6" :md="6" :lg="6">
                <TextField
                  v-model="exportQuantityRate"
                  type="number"
                  suffix="%"
                  label="License calculation rate (1.33)"
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" :xs="12" :sm="6" :md="6" :lg="6">
                <TextField
                  v-model="exportQuantityLicense"
                  rules="required"
                  type="number"
                  showIcons
                  :showOnlyErrorIcons="true"
                  :loading="isTabFormLoading || savingExportJob"
                  label="Debit Quantity under License (Import qty)"
                />
              </v-col>
              <v-col cols="12" :xs="12" :sm="6" :md="6" :lg="6">
                <AutoComplete
                  v-model="whetherIndegenousDropdownValue"
                  :return-object="true"
                  :items="indegenousTypes"
                  item-text="text"
                  rules="required"
                  required
                  :loading="isTabFormLoading || savingExportJob"
                  label="Indegenous Type"
                />
              </v-col>
            </v-row>
            <div class="d-block d-sm-flex justify-end">
              <v-btn
                color="button-primary"
                outlined
                :block="breakpointXs"
                large
                width="140"
                :class="{ 'my-3 mr-3': !breakpointXs }"
                @click="cancelLicenseModalActionHandler"
              >
                <span class="font-weight-bold fs-15">Cancel</span>
              </v-btn>
              <v-btn
                width="140"
                color="button-primary"
                large
                :block="breakpointXs"
                :class="{ 'white--text': true, 'my-3': !breakpointXs, 'ml-0 mt-3': breakpointXs }"
                :loading="isTabFormLoading || savingExportJob"
                @click="passes(addLicense)"
              >
                <span class="font-weight-bold fs-15">Add</span>
              </v-btn>
            </div>
          </ValidationObserver>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-row>
      <v-col cols="12" :xs="12" :sm="6" :md="6" :lg="6">
        <div class="d-sm-flex justify-start" :class="{ 'text-center': breakpointXs }">
          <v-btn
            width="140"
            color="info"
            large
            class="white--text"
            :loading="isTabFormLoading || savingExportJob"
            @click="$emit('change-tab', 1)"
          >
            <v-icon class="font-weight-bold fs-15 mr-2">fa fa-arrow-circle-left</v-icon>
            <span class="font-weight-bold fs-15">Previous</span>
          </v-btn>
        </div>
      </v-col>
      <v-col cols="12" :xs="12" :sm="6" :md="6" :lg="6">
        <div class="d-sm-flex justify-end" :class="{ 'text-center': breakpointXs }">
          <v-btn
            width="140"
            color="button-primary"
            large
            class="white--text"
            :loading="isTabFormLoading || savingExportJob"
            @click="saveLicenses"
          >
            <span class="font-weight-bold fs-15">Save</span>
          </v-btn>
          <div class="ml-2 mr-2 my-1"></div>
          <v-btn
            width="140"
            color="info"
            large
            class="white--text"
            :loading="isTabFormLoading || savingExportJob"
            @click="$emit('change-tab', 2)"
          >
            <span class="font-weight-bold fs-15">Next</span>
            <v-icon class="font-weight-bold fs-15 ml-2">fa fa-arrow-circle-right</v-icon>
          </v-btn>
        </div>
      </v-col>
    </v-row>
  </div>
</template>
<script>
import { ValidationObserver } from "vee-validate";
import TextField from "@/components/TextField";
import DateField from "@/components/DateField";
import AutoComplete from "@/components/AutoComplete";
import * as MT from "@/modules/DashboardModule/modules/ImportExportModule/modules/ExportModule/store/mutationTypes";
import handleExportJobMixin from "@/modules/DashboardModule/modules/ImportExportModule/mixins/handleExportJobMixin";
import commonMethodsMixin from "@/modules/commonMethodsMixin";
export default {
  name: "LicenseTab",
  components: {
    ValidationObserver,
    TextField,
    AutoComplete,
    DateField
  },
  props: {
    itemSrNo: {
      type: Number,
      default: 1
    },
    invoiceSrNo: {
      type: Number,
      default: 1
    },
    schemeAbbreviation: {
      type: String,
      default: "EPCG"
    }
  },
  data() {
    return {
      indegenousTypes: [
        {
          text: "I - Indegenous",
          textIdentifier: "N"
        },
        {
          text: "M - Imported",
          textIdentifier: "M"
        }
      ],
      description: "",
      search: "",
      unit: "",
      isTabFormLoading: false,
      dialog: false
    };
  },
  beforeDestroy() {
    this.makeFieldsNull();
  },
  mixins: [commonMethodsMixin, handleExportJobMixin],
  methods: {
    saveLicenses() {
      this.saveExportJob();
      return;
    },
    updateActionHandler(license) {
      this.srNo = license.srNo;
      this.$store.commit(MT.SET_LICENSE_FROM_EXPORT_JOB, { ...license });
      this.dialog = true;
      return;
    },
    deleteActionHandler(license) {
      this.$store.commit(MT.REMOVE_LICENSE_FROM_EXPORT_JOB, { ...license });
      this.$store.commit(MT.REASSIGN_SRNO_TO_LICENSES_IN_EXPORT_JOB, { ...license });
      return;
    },
    cancelLicenseModalActionHandler() {
      this.dialog = false;
    },
    addNewLicense() {
      this.makeFieldsNull();
      this.srNo = this.licenses.length + 1;
      this.dialog = true;
      return;
    },
    addLicense() {
      const license = { ...this.$store.getters.license };
      license.itemSrNo = this.itemSrNo;
      license.invoiceSrNo = this.invoiceSrNo;
      license.schemeAbbreviation = this.schemeAbbreviation;
      this.$store.commit(MT.SET_LICENSES_IN_EXPORT_JOB, { ...license });
      this.dialog = false;
      this.makeFieldsNull();
      return;
    },
    makeFieldsNull() {
      this.srNo = null;
      this.licenseNo = null;
      this.licenseDate = "";
      this.description = null;
      this.unit = null;
      this.whetherIndegenous = "";
      this.whetherIndegenousDropdownValue = "";
      this.itemsnoPartE = null;
      this.itemsnoPartC = null;
      return;
    }
  },
  computed: {
    licenses() {
      return this.$store.getters.exportJob.licenses.filter(license => {
        if (
          license.itemSrNo === this.itemSrNo &&
          license.invoiceSrNo === this.invoiceSrNo &&
          license.schemeAbbreviation === this.schemeAbbreviation
        ) {
          return license;
        }
        return null;
      });
    },
    srNo: {
      get() {
        return this.$store.state.ExportModuleStore.license.srNo;
      },
      set(value) {
        this.$store.commit(MT.SET_LICENCE_SR_NO, { value });
      }
    },
    licenseNo: {
      get() {
        return this.$store.state.ExportModuleStore.license.registrationNo;
      },
      set(value) {
        this.$store.commit(MT.SET_LICENCE_REGISTRATION_NO, { value });
      }
    },
    licenseDate: {
      get() {
        return this.$store.state.ExportModuleStore.license.registrationDate;
      },
      set(value) {
        this.$store.commit(MT.SET_LICENCE_REGISTRATION_DATE, { value });
      }
    },
    itemsnoPartE: {
      get() {
        return this.$store.state.ExportModuleStore.license.itemSrNoInPart_E;
      },
      set(value) {
        this.$store.commit(MT.SET_LICENCE_SR_NO_IN_PART_E, {
          value
        });
      }
    },
    itemsnoPartC: {
      get() {
        return this.$store.state.ExportModuleStore.license.itemSrNoInPart_C;
      },
      set(value) {
        this.$store.commit(MT.SET_LICENCE_SR_NO_IN_PART_C, {
          value
        });
      }
    },
    quantityDropdownValue: {
      get() {
        return this.$store.state.ExportModuleStore.license.quantityDropdownValue;
      },
      set(value) {
        this.$store.commit(MT.SET_LICENCE_QUANTITY_DROPDOWN_VALUE, {
          value: value.text
        });
      }
    },
    quantity: {
      get() {
        return this.$store.state.ExportModuleStore.item.quantity;
      },
      set(value) {
        this.$store.commit(MT.SET_LICENCE_QUANTITY, {
          value
        });
        this.exportQuantityLicense = (parseFloat(this.exportQuantityRate) * parseFloat(value)).toFixed(3);
        return;
      }
    },
    exportQuantityRate: {
      get() {
        return 1.33;
      },
      set(value) {
        this.exportQuantityLicense = (parseFloat(value) * parseFloat(this.quantity)).toFixed(3);
        return;
      }
    },
    exportQuantityLicense: {
      get() {
        const exportQuantityLicense = this.$store.state.ExportModuleStore.license.exportQuantity;
        if (exportQuantityLicense !== undefined && exportQuantityLicense !== null) {
          return exportQuantityLicense;
        }
        return (parseFloat(this.exportQuantityRate) * parseFloat(this.quantity)).toFixed(3);
      },
      set(value) {
        this.$store.commit(MT.SET_LICENCE_EXPORT_QUANTITY, {
          value
        });
      }
    },
    whetherIndegenousDropdownValue: {
      get() {
        return this.$store.state.ExportModuleStore.license.whetherIndegenousDropdownValue;
      },
      set(whetherIndegenousObject) {
        this.$store.commit(MT.SET_LICENCE_WHETHER_INDEGENOUS_DROPDOWN_VALUE, {
          value: whetherIndegenousObject.text
        });
        this.whetherIndegenous = whetherIndegenousObject.textIdentifier;
        return;
      }
    },
    whetherIndegenous: {
      get() {
        return this.$store.state.ExportModuleStore.license.whetherIndegenous;
      },
      set(value) {
        this.$store.commit(MT.SET_LICENCE_WHETHER_INDEGENOUS, {
          value
        });
      }
    },
    tableHeaders() {
      return [
        {
          text: "Sr No",
          value: "srNo",
          align: "center"
        },
        {
          text: "EDI License No",
          value: "registrationNo",
          align: "center"
        },
        {
          text: "EDI Date",
          value: "registrationDate",
          align: "center"
        },
        {
          text: "Export Quantity under License",
          value: "exportQuantity",
          align: "center"
        },
        {
          text: "Edit",
          value: "edit",
          align: "center"
        },
        {
          text: "Delete",
          value: "delete",
          align: "center"
        }
      ];
    },
    units() {
      return this.$store.getters.units;
    }
  }
};
</script>
<style lang="scss">
.epcg-tab {
  min-height: 350px;

  &__table {
    .v-data-table {
      background: transparent !important;
    }
  }
}
</style>
